import { gql } from 'graphql-tag';

const nsMarkNotificationAsRead = gql`
  mutation nsMarkNotificationAsRead($ids: [ID!]!) {
    nsMarkNotificationAsRead(ids: $ids) {
      code
      success
      message
      notifications {
        id
        refId
        type
        title
        titleShort
        createdAt
        readAt
        contentType
        content {
          ... on NSNotificationContentHTML {
            html
          }
        }
        contentText
        imageUrl
        metadata
      }
    }
  }
`;

export { nsMarkNotificationAsRead };
